import * as ActionTypes from '../../app/ActionTypes';
import * as API from '../../webAPI/MKSService';

function arrayToObject(array, keyField) {
	return Object.assign(
		{},
		...array.map(item => ({ [item[keyField]]: item }))
	);
}

// function addParentLockingId(lockings) {
// 	console.log('lockings', lockings);
// 	return lockings.map(locking => {
// 		const isRootLocking = locking.lft === 1;
// 		if (isRootLocking) return locking;
//
// 		const parentLockings = lockings.filter(locking2 => {
// 			if (locking2.lft < locking.lft && locking2.rgt > locking.rgt)
// 				return true;
// 		});
//
// 		console.log(locking);
// 		console.log('parentLockings', parentLockings);
// 		const directParent = parentLockings[parentLockings.length - 1];
//
// 		return {
// 			...locking,
// 			parent_locking_id: directParent.locking_id
// 		};
// 	});
// }

export function toggleGroup(lockingId) {
	return {
		type: ActionTypes.TOGGLE_GROUP,
		lockingId
	};
}

export function closeLockingForm() {
	return {
		type: ActionTypes.CLOSE_LOCKING_FORM
	};
}

export function getLockingsRequest(projectId) {
	return function(dispatch) {
		dispatch({ type: ActionTypes.GET_LOCKINGS_REQUEST });

		return API.getLockings(projectId).then(
			error => dispatch({ type: ActionTypes.GET_LOCKINGS_FAIL, error }),
			result =>
				dispatch({
					type: ActionTypes.GET_LOCKINGS_SUCCESS,
					lockingsByIds: arrayToObject(result, 'locking_id')
				})
		);
	};
}

export function saveLockingRequest(
	project_id,
	fields,
	lockingId,
	isLocking,
	rootId
) {
	return function(dispatch) {
		dispatch({ type: ActionTypes.SAVE_LOCKING_REQUEST });

		const parentLockingId = fields.parent_locking_id || rootId;
		return API.createLocking(
			project_id,
			fields,
			lockingId,
			isLocking,
			parentLockingId
		).then(
			error => dispatch({ type: ActionTypes.SAVE_LOCKING_FAIL, error }),
			result => {
				dispatch({
					type: ActionTypes.SAVE_LOCKING_SUCCESS,
					lockingsByIds: arrayToObject(result, 'locking_id')
				});
			}
		);
	};
}

export function deleteLockingRequest(projectId, lockingId) {
	return function(dispatch) {
		dispatch({
			type: ActionTypes.DELETE_LOCKING_REQUEST,
			lockingId
		});
		return API.deleteLocking(projectId, lockingId).then(
			error => {
				dispatch({
					type: ActionTypes.DELETE_LOCKING_FAIL,
					error
				});
			},
			result => {
				dispatch({
					type: ActionTypes.DELETE_LOCKING_SUCCESS,
					lockingsByIds: arrayToObject(result, 'locking_id')
				});
				dispatch({
					type: ActionTypes.CLOSE_LOCKING_FORM
				});
			}
		);
	};
}

export function cloneLockingRequest(project_id, locking_id, iteration) {
	return function(dispatch) {
		dispatch({
			type: ActionTypes.CLONE_LOCKING_REQUEST
		});
		return API.cloneLocking(project_id, locking_id, iteration).then(
			error => {
				dispatch({
					type: ActionTypes.CLONE_LOCKING_FAIL,
					error
				});
			},
			result => {
				dispatch({
					type: ActionTypes.CLONE_LOCKING_SUCCESS,
					lockingsByIds: arrayToObject(result, 'locking_id')
				});
				dispatch({
					type: ActionTypes.CLOSE_LOCKING_FORM
				});
			}
		);
	};
}

export function moveLockingRequest(
	projectId,
	locking,
	parentLockingId,
	afterLockingId
) {
	return function(dispatch) {
		dispatch({
			type: ActionTypes.MOVE_LOCKING_REQUEST
		});
		return API.moveLocking(
			projectId,
			locking,
			parentLockingId,
			afterLockingId
		).then(
			error => dispatch({ type: ActionTypes.MOVE_LOCKING_FAIL, error }),
			result => {
				dispatch({
					type: ActionTypes.MOVE_LOCKING_SUCCESS,
					lockingsByIds: arrayToObject(result, 'locking_id')
				});
			}
		);
	};
}



// WEBPACK FOOTER //
// ./src/js/plan/lockings/lockingsActions.js